export default __webpack_public_path__ + "static/media/img3.702810c5.jpg";